import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#0B1C2C] border-t border-[#F2F4F8]/10 py-8 px-4 sm:px-6 lg:px-8" data-id="element-105">
      <div className="max-w-5xl mx-auto text-center" data-id="element-106">
        <p className="text-[#F2F4F8]/60 text-sm max-w-2xl mx-auto" data-id="element-107">
          © 2026 El Manual Prohibido De La Creatina: Todo Lo Que Las Marcas No
          Te Cuentan. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}